import { NgModule } from '@angular/core';

import { BuyTicketPageRoutingModule } from './buy-ticket-routing.module';

import { BuyTicketPage } from './buy-ticket.page';
import { SharedModule } from '@app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BuyTicketFormComponent } from './buy-ticket-form/buy-ticket-form.component';
import { LatestPurchasesComponent } from './latest-purchases/latest-purchases.component';
import { NotLoggedInInfoCardComponent } from './not-logged-in-info-card/not-logged-in-info-card.component';

@NgModule({
  imports: [
    SharedModule,
    BuyTicketPageRoutingModule,
    ReactiveFormsModule
  ],
  declarations: [BuyTicketPage, BuyTicketFormComponent, LatestPurchasesComponent, NotLoggedInInfoCardComponent]
})
export class BuyTicketPageModule {}
